import { render } from "./AppointmentInputPopover.vue?vue&type=template&id=49616118"
import script from "./AppointmentInputPopover.vue?vue&type=script&lang=js"
export * from "./AppointmentInputPopover.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__